export default __webpack_public_path__ + "static/media/four-digits.bae4fa0f.svg";